module.exports = __webpack_public_path__ + "static/media/venda1.35449846.png";